<template>
  <div>
    <v-toolbar v-if="theme" flat :color="theme" dark>
      <v-toolbar-title><v-icon>{{icon}}</v-icon> {{title}}</v-toolbar-title>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="values"
      :expand="expand"
      
    >
      <template v-slot:items="props">
        <tr  :active="props.selected" @click="props.selected = !props.selected; props.expanded = !props.expanded; props.expanded? $emit('selected', props.item): $emit('unselected', props.item)">
            <td v-for="h in headers" :key="h.value" class="text-xs-right text-justify" style="text-align:left">{{ props.item[h.value] }}</td>
            <td v-if="!noedit">
              <v-btn fab icon small><v-icon small>edit</v-icon></v-btn>
            </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

  export default {
    name: "ItemList",

    props: {
      theme: String,
      icon: String,
      title: String,
      headers: Array,
      values: Array,
      noedit: Object
    },

    data: function () {
      return {
        expand: false,
        selected: []
      }
    }
  }
  
  </script>